import { DictionaryRecordDto } from '@lmt/shared-types';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React, { FC } from 'react';
import { MultiSelectDropDownInput } from '../../../common/ui-kit/inputs/dropdown/MultiSelectDropDownInput';
import { useActiveTags } from '../../../common/ui-kit/tags/useTags';
interface Props {
  selectedTagIds: number[] | undefined | null;
  onChange: (tagIds: number[]) => void;
}

export const TagsFilter: FC<Props> = React.memo(function TagsFilter(props) {
  const i18next = useScopedTranslation('patients.list.filter');
  const tags: DictionaryRecordDto[] = useActiveTags();

  return (
    <div data-test-id="tagsFilter">
      <MultiSelectDropDownInput
        options={tags}
        idFunction={'id'}
        getOptionLabel={'value'}
        placeholder={i18next.t('control.select_tags')}
        allSelectedLabel={i18next.t('control.all_tags')}
        onValueChanged={(value) => {
          const ids = value.map((t) => t.id);
          props.onChange(ids);
        }}
        values={props.selectedTagIds}
        headerTitle={i18next.t('fields.tags')}
        hasSearchFilter={true}
      />
    </div>
  );
});
